import React, { useRef } from 'react';
import NavBar from './assets/components/header';
import Landing from './assets/pages/landing';
import AboutUs from './assets/pages/aboutus';
import WhyChooseUsCarousel from './assets/pages/caraousel';
import ServicesPage from './assets/pages/services';
import ClientReviews from './assets/pages/ourwork';
import Footer from './assets/components/footer';

function App() {
  const landingRef = useRef(null);
  const aboutRef = useRef(null);
  const servicesRef = useRef(null);
  const portfolioRef = useRef(null);
  const contactRef = useRef(null);

  const scrollToSection = (elementRef) => {
    elementRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="app-container">
      <NavBar 
        onHomeClick={() => scrollToSection(landingRef)}
        onAboutClick={() => scrollToSection(aboutRef)}
        onServicesClick={() => scrollToSection(servicesRef)}
        onPortfolioClick={() => scrollToSection(portfolioRef)}
        onContactClick={() => scrollToSection(contactRef)}
      />
      <div className="page-content">
        <div ref={landingRef}>
          <Landing />
        </div>
        <WhyChooseUsCarousel />
        <div ref={servicesRef}>
          <ServicesPage />
        </div>
        <div ref={portfolioRef}>
          <ClientReviews />
        </div>
        <div ref={aboutRef}>
          <AboutUs />
        </div>
        <div ref={contactRef}>
          <Footer />
        </div>
      </div>
    </div>
  );
}

export default App;